import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface ConfirmDialogState {
    show: boolean;
    params: object;
    routeName: string;
    method: string;
}

const initialState: ConfirmDialogState = {
    show: false,
    params: {},
    routeName: "",
    method: "",
};

const confirmDialogSlice = createSlice({
    name: "confirmDialog",
    initialState,
    reducers: {
        setConfirmParams: (state, action: PayloadAction<object>) => {
            state.params = action.payload;
        },
        setConfirmRouteName: (state, action: PayloadAction<string>) => {
            state.routeName = action.payload;
        },
        setConfirmShow: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        setConfirmMethod: (state, action: PayloadAction<string>) => {
            state.method = action.payload
        }
    },
});

export const {
    setConfirmParams,
    setConfirmRouteName,
    setConfirmShow,
    setConfirmMethod} = confirmDialogSlice.actions;

export default confirmDialogSlice.reducer;